import { useLocation } from 'react-router-dom';

function useSearchParamQuery() {
  return new URLSearchParams(useLocation().search);
}

export default useSearchParamQuery;
